<template>
    <div id="title">
        <div class="title-gradient">
            {{ title }}
            <div class="title-square"></div>
            <div class="title-line"></div>
        </div>
        <div class="title-border"></div>
    </div>
</template>

<script>
export default {
    props:['title']
}
</script>

<style lang="scss" scoped>
    #title{
        width: 100%;
        height: 34px;
        background-color: #fff;
        margin-bottom: 16px;
        .title-gradient{
            height: 32px;
            color: #fff;
            display: inline-block;
            padding: 0 32px;
            line-height: 32px;
            font-weight: 700;
            margin-left: 30px;
            background: linear-gradient(to right, rgba(228, 0, 128, 1), rgba(228, 0, 128, 0.50), rgba(227, 3, 130, 0));
            position: relative;
            .title-square{
                position: absolute;
                width: 18px;
                height: 18px;
                top: -9px;
                left: -9px;
                background: rgba(228,0,128,0.16);
            }
            .title-line{
                position: absolute;
                width: 30px;
                bottom: 0px;
                left: -30px;
                height: 5px;
                background: linear-gradient(to left, rgba(228, 0, 128, 1), rgba(228, 0, 128, 0.50), rgba(227, 3, 130, 0));
            }
        }
        .title-border{
            width: 100%;
            height: 2px;
            background-color: rgba(228, 0, 128, 1);
        }
    }
</style>